import styled from 'styled-components';

export default styled.div`
  height: 100%;
  .export-wrapper {
    margin: 24px 0;

    .export {
      width: 124px;
      height: 44px;
      border-radius: 24px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 6px;
      }
    }
    .Mui-disabled {
      color: #fff !important;
      box-shadow: none;
      background-color: rgb(189, 189, 189) !important;
    }
  }
`;
